import { useEffect, type RefObject } from "react";

/**
 * Закрытие всплывающей панели шапки (колокольчик, меню аккаунта): щелчок мимо
 * панели и её кнопки или Escape. Слушатели вешаются только пока панель открыта
 * и только в эффекте — при рендере в тестах window не нужен.
 */
export function useDismiss(
  open: boolean,
  ref: RefObject<HTMLElement | null>,
  close: () => void,
): void {
  useEffect(() => {
    if (!open) return;
    const onPointer = (event: MouseEvent | TouchEvent) => {
      const target = event.target as Node | null;
      if (target && ref.current?.contains(target)) return;
      close();
    };
    const onKey = (event: KeyboardEvent) => {
      if (event.key !== "Escape" || event.defaultPrevented) return;
      // Escape закрывает только панель: тур и мобильное меню пропускают
      // обработанное нажатие (defaultPrevented), одно нажатие — одно действие.
      event.preventDefault();
      close();
    };
    document.addEventListener("mousedown", onPointer);
    document.addEventListener("touchstart", onPointer);
    document.addEventListener("keydown", onKey, true);
    return () => {
      document.removeEventListener("mousedown", onPointer);
      document.removeEventListener("touchstart", onPointer);
      document.removeEventListener("keydown", onKey, true);
    };
  }, [open, ref, close]);
}
